exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-warning[data-v-8d8613c8]{color:#ffc107}", ""]);

// exports
